var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gpt-work-order-info" }, [
    _vm.extendInfo.statusCount.all <= 10
      ? _c(
          "div",
          [
            _vm.extendInfo.statusCount.all == 0
              ? _c("div", [
                  _vm._v("主人，您"),
                  _c("span", { staticClass: "y-f-b" }, [
                    _vm._v(_vm._s(_vm.extendInfo.chatParams.dateRange.dateStr)),
                  ]),
                  _vm._v("暂无电商返款订单。"),
                ])
              : _c("div", [
                  _vm._v("主人，您"),
                  _c("span", { staticClass: "y-f-b" }, [
                    _vm._v(_vm._s(_vm.extendInfo.chatParams.dateRange.dateStr)),
                  ]),
                  _vm._v("有"),
                  _c("span", { staticClass: "y-f-b" }, [
                    _vm._v(" " + _vm._s(_vm.extendInfo.statusCount.all) + " "),
                  ]),
                  _vm._v("个 "),
                  _c("span", { staticClass: "y-fc-FF860E" }, [
                    _vm._v(_vm._s(_vm.extendInfo.chatParams.status || "")),
                  ]),
                  _vm._v(" 返款订单。 "),
                  _vm.extendInfo.statusCount["10"]
                    ? _c("span", [
                        _c("span", { staticClass: "y-fw-bold" }, [
                          _vm._v(_vm._s(_vm.refundType["10"].name)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "y-fc-FF860E" }, [
                          _vm._v(_vm._s(_vm.extendInfo.statusCount["10"])),
                        ]),
                        _vm._v(" 个，"),
                      ])
                    : _vm._e(),
                  _vm.extendInfo.statusCount["20"]
                    ? _c("span", [
                        _c("span", { staticClass: "y-fw-bold" }, [
                          _vm._v(_vm._s(_vm.refundType["20"].name)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "y-fc-FF860E" }, [
                          _vm._v(_vm._s(_vm.extendInfo.statusCount["20"])),
                        ]),
                        _vm._v(" 个，"),
                      ])
                    : _vm._e(),
                  _vm.extendInfo.statusCount["30"]
                    ? _c("span", [
                        _c("span", { staticClass: "y-fw-bold" }, [
                          _vm._v(_vm._s(_vm.refundType["30"].name)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "y-fc-35A921" }, [
                          _vm._v(_vm._s(_vm.extendInfo.statusCount["30"])),
                        ]),
                        _vm._v(" 个，"),
                      ])
                    : _vm._e(),
                  _vm.extendInfo.statusCount["40"]
                    ? _c("span", [
                        _c("span", { staticClass: "y-fw-bold" }, [
                          _vm._v(_vm._s(_vm.refundType["40"].name)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "y-fc-gray" }, [
                          _vm._v(_vm._s(_vm.extendInfo.statusCount["40"])),
                        ]),
                        _vm._v(" 个，"),
                      ])
                    : _vm._e(),
                  _vm.extendInfo.statusCount["50"]
                    ? _c("span", [
                        _c("span", { staticClass: "y-fw-bold" }, [
                          _vm._v(_vm._s(_vm.refundType["50"].name)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "y-fc-FD0206" }, [
                          _vm._v(_vm._s(_vm.extendInfo.statusCount["50"])),
                        ]),
                        _vm._v(" 个，"),
                      ])
                    : _vm._e(),
                  _vm._v(" 申请后无特殊情况7个工作日到账。 "),
                ]),
            _vm.extendInfo.page && _vm.extendInfo.page.length
              ? _c("div", { staticClass: "split-line" })
              : _vm._e(),
            _vm._l(_vm.extendInfo.page || [], function (item, idx) {
              return _c("div", { key: idx, staticClass: "y-fl-40" }, [
                _c(
                  "div",
                  {
                    staticClass: "y-f y-f-a y-f-jb",
                    class: { "y-mt-20": idx != 0 },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "y-f y-f-a y-f-js y-fl-h y-f-1 s-td" },
                      [
                        _c("span", { staticClass: "y-mr-10" }, [
                          _vm._v(_vm._s(item.mallName)),
                        ]),
                        item.platformCode
                          ? _c("svg-icon", {
                              staticClass: "seller-icon",
                              attrs: {
                                iconClass:
                                  _vm.PLATFORMICONMAP[item.platformCode],
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("div", [
                      _c(
                        "span",
                        {
                          staticClass: "process-status",
                          class: {
                            "refund-back-color":
                              _vm.getStausColor(item.checkStatusName) == 1,
                            "refund-green-color":
                              _vm.getStausColor(item.checkStatusName) == 2,
                            "refund-gray-color":
                              _vm.getStausColor(item.checkStatusName) == 3,
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(item.checkStatusName))])]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "y-f y-f-a y-f-jb y-jb-baseline y-mt-10 y-fs-28",
                  },
                  [
                    _vm._m(0, true),
                    _c("div", { staticClass: "y-fc-gray" }, [
                      _c("span", [_vm._v(_vm._s(item.refundCode))]),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "y-f y-f-a y-f-jb y-jb-baseline y-mt-10 y-fs-28",
                  },
                  [
                    _vm._m(1, true),
                    _c("div", { staticClass: "y-fc-gray" }, [
                      _c("span", [_vm._v(_vm._s(item.paymentAmount) + " 元")]),
                    ]),
                  ]
                ),
                item.remark
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "y-f y-f-a y-f-jb y-jb-baseline y-mt-10 y-fs-28",
                      },
                      [
                        _vm._m(2, true),
                        _c("div", { staticClass: "y-fc-FD0206" }, [
                          _c("span", [_vm._v(_vm._s(item.remark))]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                idx != _vm.extendInfo.page.length - 1
                  ? _c("div", { staticClass: "split-line" })
                  : _vm._e(),
              ])
            }),
            _c("div", { staticClass: "split-line" }),
            _c("div", { staticClass: "y-t-ac" }, [
              _c(
                "span",
                {
                  staticClass: "nouse-text-btn",
                  on: { click: _vm.viewRefundRuleFn },
                },
                [_vm._v("查看返款规则")]
              ),
            ]),
          ],
          2
        )
      : _c("div", [
          _c("div", [
            _vm._v("主人，您"),
            _c("span", { staticClass: "y-f-b" }, [
              _vm._v(_vm._s(_vm.extendInfo.chatParams.dateRange.dateStr)),
            ]),
            _vm._v("有 "),
            _c("span", { staticClass: "y-f-b y-fc-151719" }, [
              _vm._v(_vm._s(_vm.extendInfo.statusCount.all) + "个"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "y-fc-FF860E" }, [
              _vm._v(_vm._s(_vm.extendInfo.chatParams.status || "")),
            ]),
            _vm._v(" 返款订单， 其中："),
          ]),
          _vm.extendInfo.statusCount["10"]
            ? _c("div", { staticClass: "y-fw-bold y-mt-12" }, [
                _c("span", [_vm._v(_vm._s(_vm.refundType["10"].name))]),
                _vm._v(" "),
                _c("span", { staticClass: "y-fc-FF860E" }, [
                  _vm._v(_vm._s(_vm.extendInfo.statusCount["10"]) + " 个"),
                ]),
              ])
            : _vm._e(),
          _vm.extendInfo.statusCount["20"]
            ? _c("div", { staticClass: "y-fw-bold y-mt-12" }, [
                _c("span", [_vm._v(_vm._s(_vm.refundType["20"].name))]),
                _vm._v(" "),
                _c("span", { staticClass: "y-fc-FF860E" }, [
                  _vm._v(_vm._s(_vm.extendInfo.statusCount["20"]) + " 个"),
                ]),
              ])
            : _vm._e(),
          _vm.extendInfo.statusCount["30"]
            ? _c("div", { staticClass: "y-fw-bold y-mt-12" }, [
                _c("span", [_vm._v(_vm._s(_vm.refundType["30"].name))]),
                _vm._v(" "),
                _c("span", { staticClass: "y-fc-35A921" }, [
                  _vm._v(_vm._s(_vm.extendInfo.statusCount["30"]) + " 个"),
                ]),
              ])
            : _vm._e(),
          _vm.extendInfo.statusCount["40"]
            ? _c("div", { staticClass: "y-fw-bold y-mt-12" }, [
                _c("span", [_vm._v(_vm._s(_vm.refundType["40"].name))]),
                _vm._v(" "),
                _c("span", { staticClass: "y-fc-gray" }, [
                  _vm._v(_vm._s(_vm.extendInfo.statusCount["40"]) + " 个"),
                ]),
              ])
            : _vm._e(),
          _vm.extendInfo.statusCount["50"]
            ? _c("div", { staticClass: "y-fw-bold y-mt-12" }, [
                _c("span", [_vm._v(_vm._s(_vm.refundType["50"].name))]),
                _vm._v(" "),
                _c("span", { staticClass: "y-fc-FD0206" }, [
                  _vm._v(_vm._s(_vm.extendInfo.statusCount["50"]) + " 个"),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "split-line" }),
          _c("div", { staticClass: "y-f y-f-a y-f-jb" }, [
            _c("div", { staticClass: "y-t-ac y-bw-50" }, [
              _c(
                "span",
                {
                  staticClass: "nouse-text-btn",
                  on: { click: _vm.goRefundPageFn },
                },
                [_vm._v("查看明细")]
              ),
            ]),
            _c("div", { staticClass: "y-t-ac y-bw-50" }, [
              _c(
                "span",
                {
                  staticClass: "nouse-text-btn",
                  on: { click: _vm.viewRefundRuleFn },
                },
                [_vm._v("查看返款规则")]
              ),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "y-w-180 y-f-shrink" }, [
      _c("span", { staticClass: "y-fw-bold" }, [_vm._v("返款单号：")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "y-w-180 y-f-shrink" }, [
      _c("span", { staticClass: "y-fw-bold" }, [_vm._v("返款金额：")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "y-w-180 y-f-shrink" }, [
      _c("span", { staticClass: "y-fw-bold" }, [_vm._v("驳回原因：")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }